import {cs}                        from "@Common/react/chain-services";
import {consumeContext}            from "@Common/react/context";
import {Load}                      from "@Common/react/load";
import {scopedState}               from "@Common/react/scoped-state";
import {Static2}                   from "@Common/react/static-2";
import {UseState}                  from "@Common/react/use-state";
import {setCurrentToSaved}         from "@Common/ui-components/heavy/item-options/modules/set-current-to-saved";
import {ErrorHighlighter}          from "@Common/ui-components/light/error-highlighter";
import {scrollIntoView}            from "@Common/ui-components/light/scroll-into-view";
import {changeNestedValue}         from "@Common/utils/arr-path";
import {parseDateFormat}           from "@Common/utils/date/parse-date-format";
import {addDate, ge, today}        from "@Common/utils/date-object";
import {chain}                     from "@Common/utils/fs";
import {equalDeep, omit}           from "@Common/utils/objects";
import {PROGRAM_TYPE}              from "@Xpresso/routes/common/logic/program";
import {AcceptableFulfillmentDate} from "@Common/logic/future-fulfillment/acceptable-fulfillment-date";

const df = parseDateFormat("yyyy-mm-dd");

export const FutureFulfillmentLogic = ({item, next: rootNext}) => cs(
    consumeContext("apis"),
    consumeContext("systemConstants"),
    ["holidays", ({apis}, next) => Load({
        fetch: () => apis.next.getHolidays(),
        next,
    })],
    ["state", (_, next) => UseState({
        getInitValue: () => chain(
            {
                selected     : item?.selections?.futureFulfillment,
                scheduledDate: chain(
                    item?.selections?.scheduledDate,
                    (_) => _ && df.parseDate(_),
                ),
            },
            (_) => ({
                saved  : _,
                current: _,
            }),
        ),
        next,
    })],

    ["eh", (_, next) => ErrorHighlighter({next})],
    ["domRef", (_, next) => Static2({next})],
    consumeContext("company"),

    ["step1", ({}, next) => rootNext({
        cleanItem: (item) => changeNestedValue(item, ["selections"], (_) => omit(_, ["futureFulfillment", "scheduledDate"])),
        next,
    })],

    ({step1, state, company, domRef, eh, holidays, systemConstants}) => {
        const valid = !state.value.current.selected || (
            state.value.current.scheduledDate &&
            ge(addDate(today(), +(systemConstants.value?.MAX_NUM_DAYS_OUT_FOR_SCHEDULING_ORDERS??90)), state.value.current.scheduledDate) &&
            ge(state.value.current.scheduledDate, addDate(today(), +(systemConstants.value?.MIN_NUM_DAYS_OUT_FOR_SCHEDULING_ORDERS??2))) &&
            AcceptableFulfillmentDate({holidays})(state.value.current.scheduledDate)
        );
        return step1.next({
            summaryLines: !!state.value.current.selected && state.value.current.scheduledDate && [{
                label: (
                    "Scheduled Fulfillment Date: " +
                    parseDateFormat("mm/dd/yy").formatDate(
                        state.value.current.scheduledDate
                    )
                )
            }],

            ...!company?.prefs?.enableScheduledOrder || item?.programType === PROGRAM_TYPE.SCHEDULED_CAMPAIGNS ? (
                null
            ) : {
                itemEditor: {
                    $name: "Future fulfillment",
                    prepareSave: (item) => ({
                        newValue: changeNestedValue(item, ["selections"], (_) => ({
                            ..._,
                            ...state.value.current.selected && {
                                futureFulfillment: state.value.current.selected,
                                scheduledDate: chain(
                                    state.value.current.scheduledDate,
                                    (_) => _ && df.formatDate(_),
                                ),
                            },
                        })),
                        onSaved: () => setCurrentToSaved(state),
                    }),

                    changed: !equalDeep(state.value.saved, state.value.current),

                    valid,
                    errorsHandling: {
                        highlightErrors: () => {
                            scrollIntoView(domRef.get());
                            eh.start();
                        },
                    },
                },

                ui: {
                    domRef: domRef.set,
                    eh,
                    state: scopedState(state, ["current"]),
                    holidays,
                    valid,
                },
            },
        });
    },
);

